module.exports = __webpack_public_path__ + "static/img/市科技创新一等奖.f08a6b6e.jpg";